<template>
  <div>
    <asc-spinner-wrapper :loading="loading">
      <asc-fault-monitor-detail-item
        :item="definition"
      ></asc-fault-monitor-detail-item>
    </asc-spinner-wrapper>
  </div>
</template>

<script>
import { AscDataDefinitionMixin } from '@/components/mixins'
import AscSpinnerWrapper from '@/components/atoms/AscSpinnerWrapper'
import AscFaultMonitorDetailItem from './AscFaultMonitorDetailItem'

export default {
  name: 'AscFaultMonitorAlert',

  components: {
    AscSpinnerWrapper,
    AscFaultMonitorDetailItem,
  },

  mixins: [AscDataDefinitionMixin],
}
</script>
